<article>
    <section class="top-section pl-4 pr-4 d-flex flex-row flex-wrap align-items-end">
        <div class="col-12 col-sm col-lg-8 p-0 pr-sm-4 pr-0">
            <ng-container
                *ngTemplateOutlet="errorCode === ErrorCode.Error403 ? template403 : template401"
            ></ng-container>
        </div>
        <div class="d-none d-sm-block">
            <img class="error-img" [src]="image" />
        </div>
    </section>
</article>
<ng-template #template401>
    <h1 class="mb-4 text-center text-sm-left">401</h1>
    <div class="description">
        <div>You must be signed in to view this page. Please sign in below.</div>
        <div *ngIf="errorMessage" class="debug-error-message mt-2">ERROR: {{ errorMessage }}</div>
    </div>
    <div class="d-flex flex-nowrap justify-content-center justify-content-sm-start">
        <app-register
            class="mr-4 mr-md-5"
            *ngIf="!isStudent"
            [showSocialIcons]="true"
            [nextURL]="nextURL"
            text="Teacher Sign In"
        >
        </app-register>
        <app-register
            [showSocialIcons]="true"
            [nextURL]="nextURL"
            [student]="true"
            text="Student Sign In"
        >
        </app-register>
    </div>
</ng-template>
<ng-template #template403>
    <h1 class="mb-4 text-center text-sm-left">403</h1>
    <div class="description">
        <div class="mb-4">This page is not available.</div>
        <div>
            Try searching for something similar, or check out our
            <a [routerLink]="[isStudent ? '/student' : '/']" title="Homepage">home page</a>
            for featured resources and collections..
        </div>
        <div *ngIf="errorMessage" class="debug-error-message mt-2">ERROR: {{ errorMessage }}</div>
    </div>
    <app-external-search-input
        class="d-block"
        placeholder="Search Keyword(s)"
    ></app-external-search-input>
</ng-template>
